import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";



const resources = {
    en: {
      translation: {
        nav: {
          testToday: "Test SEPM today!",
          products: "Products",
          partners: "Our Partners",
          testimonials: "Testimonials",
          releaseNotes: "Release Notes",
          download: "Download",
          tagline: "GIS workflow solutions",
        },
        hero: {
          badgeText: "🚀 SEPM Products 2026-01 Available Now!",
          mainHeading: "Streamlining GIS Workflows \n for Smallworld Users",
          subHeading: "Imagine a GIS tool so intuitive, your team spends less time fixing errors and more time innovating.",
          msgText: "Smallworld GIS users often struggle with inefficient tools for data conversion that cause delays and errors.\n\n At SEPM, \n we simplify GIS data management so engineers can focus on decisions, not technical hurdles",
          imageAlt: "Streamer SaaS interface",
        },
        howItWorks: {
          sectionTitle: "Test the SEPM X-Translator Today!",
          sectionDescription: "Getting Started is Easy - Follow These Steps :",
          steps: [
            {
              title: "Download the SEPM Product",
              description: "Use the link below to download the SEPM X-Translator",
            },
            {
              title: "Activate Your SEPM License",
              description: "Contact SEPM or one of our trusted partners to receive the password for the downloaded zip file and instructions for adding the SEPM product to your Smallworld session",
            },
            {
              title: "Review the Documentation",
              description: "Follow the Quickguide.pdf and additional SEPM documentation to test importing and exporting data. Try using common file formats such as DXF, GeoJSON, Shape, or KML.",
            },
            {
              title: "Explore the Features",
              description: "We are here to help! SEPM or our trusted partners can guide you through the basics and demonstrate advanced functionalities tailored to your needs.",
            },
            {
              title: "Complete Onboarding",
              description: "Collaborate with SEPM or a sales partner to ensure successful setup and integration into your workflow.",
            },
          ],
          lastStep: "Start Your SEPM Journey Today and Revolutionize Your GIS Workflows!",
        },
        keyFeatures: {
          sectionTitle: "Our Product Suite for Seamless GIS Workflows",
          sectionDescription: "With over 250 businesses worldwide relying on our solutions, we have created tools designed to streamline GIS workflows",
          features: [
            {
              title: "SEPM X-Translator",
              description: "User-friendly tool for seamless vector data import/export",
            },
            {
              title: "SEPM X-Raster",
              description: "Raster data import/export",
            },
            {
              title: "SEPM NEPLAN Interface",
              description: "Simplified network analysis integration",
            },
            {
              title: "SEPM INTERLIS Interface",
              description: "Seamlessly bridging GIS systems with robust INTERLIS import/export for Swiss data models",
            },
            {
              title: "SEPM ISYBAU Interface",
              description: "Effortlessly integrate ISYBAU XML data with Smallworld NRM Wastewater to import and export field inspection data coded per DWA-M 149-2 or DIN EN 13508-2",
            },
            {
              title: "SEPM Services",
              description: "From GIS migrations to custom software solutions, SEPM delivers innovative, precise, and future-ready services tailored to your geospatial needs",
            },
          ],
        },
        newFeature: {
          sectionTitle: "New Feature : Discover What's New !!",
          sectionDescription: "Experience the next level of functionality with our latest updates",
          introLine1: "Version SEPM 2026-01 includes extensive enhancements and improvements for the SEPM X-Translator,",
          introLine2: "the SIA405 interface, and the VSE migration tools.:",
          imageAlt: "New feature",
          features: [
            {
              title: "Supported Smallworld Versions",
              description: [
                "Supported and tested on Smallworld 5.1, 5.2, 5.3 and 6.0.",
              ],
            },
            {
              title: "New Settings Screen for X-Translator",
              description: [
                "Global X-Translator settings can now be managed via a central settings screen.",
                "This version specifically supports the configuration of Simple GUI entries",
                "Custom import and export commands can be defined as Simple GUI configurations in an XML file",
                "This makes it easier to provide existing XML configurations to end users."
              ],
            },
            {
              title: "Enhanced DXF/DWG Import with Block Tables",
              description: [
                "AutoCAD INSERT objects can be exploded and stored in dedicated translator block tables.",
                "This makes block contents, geometries, and additional style attributes available in a structured format for mapping and further processing.",
              ],
            },
            {
              title: "Improvements to the DXF/DWG Source Format",
              description: [
                "New options and rules allow for the targeted import of invisible block attributes.",
                "Naming conflicts with block attributes can be prevented through improved handling rules.",
                "The previous \"Explode Blocks\" option has been replaced with a more granular block import mode.",
              ],
            },
            {
              title: "Enhanced DWG/DXF Export",
              description: [
                "AutoCAD export now supports additional Smallworld text decorations such as borders, underlines, strikethroughs, and text dropouts.",
              ],
            },
            {
              title: "Improvements to Smallworld Exports",
              description: [
                "Object selection via Collection Predicates has been decoupled from the current ACE visibility.",
                "The \"All Geometries\" visibility setting has been expanded, enabling complete exports independent of interactive GIS visibility.",
              ],
            },
            {
              title: "Improvements to the Smallworld Target Format",
              description: [
                "A new default value mode, \"Strict (no mandatory attribute check),\" has been added.",
                "Handling of missing target worlds has been improved, with new options for controlling database change notifications and cardinality validation.",
              ],
            },
            {
              title: "Improvements to KML, Text, and Shape",
              description: [
                "KML export now uses the official KML namespace, offers a new option for coordinate dimensions, and no longer exports altitudeMode by default.",
                "In the Text source format, attribute type detection and handling of empty cells have been enhanced.",
                "In the Shape target format, the number of decimal places for float and double attributes can be configured.",
              ],
            },
            {
              title: "Support for INTERLIS 2.4 and SIA405 LKMap 2025",
              description: [
                "The new interface \"NIS Strom SIA 405, LKMAP (2025), LV95, INTERLIS 2.4 XTF\" has been added.",
                "It supports INTERLIS 2.4 tags, UUIDOID, external organizational references, and the familiar LKMap objects in the new model.",
              ],
            },
            {
              title: "Enhancements to GEONIS Migration",
              description: [
                "The migration from GEONIS to NIS Strom via the VSE intermediate model has been enhanced.",
                "This includes improved migration for route cross-sections, pipe numbers from GEONIS cross-sections, and better diagnostic and reporting functions.",
              ],
            },
            {
              title: "New Topobase Migration",
              description: [
                "A new framework, topobase_vse_migration, has been developed for transferring Autodesk Map 3D / Oracle Topobase to VSE.",
                "It supports key construction plan objects, relationships between routes, pipes, and cables, electrical topology, and surface geometries for structural objects.",
              ],
            },
          ],
        },
        downloads: {
          sectionTitle: "Product Downloads and Support",
          sectionDescription: "Experience our newest release - get it here",
          downloadFile: "sepm_26_1_0_source.zip",
          releaseNotesEnglish: "Release Notes English",
          releaseNotesGerman: "Release Notes German",
        },
        partners: {
          sectionTitle: "Our Partners",
          sectionDescription: "Empowering success through our trusted network of strategic partners",
        },
        testimonials: {
          sectionTitle: "What Our Customers Say",
          sectionDescription: "Hear from some of our valued users as they share their experiences and stories about how our solutions have made a difference. Their feedback inspires us to continually improve and deliver exceptional value.",
          reviews: [
            {
              name: "Erwin Sagesser NIS AG",
              title: "NIS AG",
              review: "One single point of truth is possible - The SEPM interfaces eliminate time-consuming post-processing work after complex data transformations. For this reason, SEPM enables customers to efficiently reuse their quality-assured data in our network information system NIS Strom",
            },
            {
              name: "Mario Schuler EW Schwyz",
              title: "",
              review: "Network information no longer needs to be entered manually into NEPLAN in a time-consuming process. It is managed centrally in NIS Strom and can be transferred conveniently with the SEPM NEPLAN Interface. Redundant and error-prone database maintenance is no longer necessary.",
            },
            {
              name: "Bernd Grossmann City of Leverkusen",
              title: "",
              review: "User-friendly, straightforward, and to the point: SEPM X-Translator has proven useful not only for standard import and export tasks. Tables with coordinates are converted into point objects with annotations in no time. Transferring data from Smallworld to Smallworld adds an interesting tool to the toolbox.",
            },
            {
              name: "Davy Bielen Fluvius",
              title: "",
              review: "Thanks to the easy-to-use SEPM X-Translator, we were able to streamline business processes.",
            },
            {
              name: "Eric Kappmeier MID",
              title: "",
              review: "Our Smallworld users have used SEPM X-Translator for years to convert Shape and DXF/DWG data in and out of our Smallworld GIS database. We believe it is by far the easiest, most accurate, and most cost-effective tool for sharing spatial data between Smallworld and other GIS systems.",
            },
          ],
        },
        footer: {
          contactUsText: "CONTACT US",
          contactUsDesc: "Robert Schweikert \n Geliswilstrasse 42, CH-6020 Emmenbrucke, Switzerland, \n +41 79 632 28 20, \n info@sepm.ch",
          platformsText: "SEPM Products | X-Translator | X-Raster | NEPLAN | INTERLIS | ISYBAU",
          copyrightText: "Copyright © 2025 SEPM, Inc. All rights reserved.",
          sections: [
            {
              title: "CONNECT WITH US",
              links: [
                { text: "LinkedIn" },
                { text: "SEPM Support" },
              ],
            },
          ],
        },
        common: {
          loading: "Loading...",
          selectLanguage: "Select language",
          languages: {
            en: "English",
            fr: "French",
            de: "German",
          },
        },
      },
    },
    fr: {
      translation: {
        nav: {
          testToday: "Testez SEPM aujourd'hui !",
          products: "Produits",
          partners: "Nos partenaires",
          testimonials: "Témoignages",
          releaseNotes: "Notes de version",
          download: "Télécharger",
          tagline: "Solutions de flux de travail SIG",
        },
        hero: {
          badgeText: "🚀 Produits SEPM 2026-01 disponibles maintenant !",
          mainHeading: "Optimiser les flux de travail SIG \n pour les utilisateurs Smallworld",
          subHeading: "Imaginez un outil SIG si intuitif que votre équipe passe moins de temps a corriger les erreurs et plus de temps a innover.",
          msgText: "Les utilisateurs de Smallworld GIS ont souvent du mal avec des outils de conversion de donnees inefficaces qui provoquent des retards et des erreurs.\n\n Chez SEPM, \n nous simplifions la gestion des donnees SIG afin que les ingenieurs se concentrent sur les decisions, pas sur les obstacles techniques",
          imageAlt: "Interface SaaS Streamer",
        },
        howItWorks: {
          sectionTitle: "Testez SEPM X-Translator aujourd'hui !",
          sectionDescription: "Demarrer est simple - suivez ces etapes :",
          steps: [
            {
              title: "Telechargez le produit SEPM",
              description: "Utilisez le lien ci-dessous pour telecharger SEPM X-Translator",
            },
            {
              title: "Activez votre licence SEPM",
              description: "Contactez SEPM ou l'un de nos partenaires de confiance pour recevoir le mot de passe du fichier zip telecharge et les instructions pour ajouter le produit SEPM a votre session Smallworld",
            },
            {
              title: "Consultez la documentation",
              description: "Suivez le fichier Quickguide.pdf et la documentation SEPM supplementaire pour tester l'import et l'export de donnees. Essayez des formats courants tels que DXF, GeoJSON, Shape ou KML.",
            },
            {
              title: "Explorez les fonctionnalites",
              description: "Nous sommes la pour vous aider ! SEPM ou nos partenaires de confiance peuvent vous guider dans les bases et presenter des fonctionnalites avancees adaptees a vos besoins.",
            },
            {
              title: "Finalisez l'integration",
              description: "Collaborez avec SEPM ou un partenaire commercial pour garantir une configuration et une integration reussies dans votre flux de travail.",
            },
          ],
          lastStep: "Commencez votre parcours SEPM aujourd'hui et revolutionnez vos flux de travail SIG !",
        },
        keyFeatures: {
          sectionTitle: "Notre gamme de produits pour des flux de travail SIG fluides",
          sectionDescription: "Avec plus de 250 entreprises dans le monde qui s'appuient sur nos solutions, nous avons cree des outils concus pour simplifier les flux de travail SIG",
          features: [
            {
              title: "SEPM X-Translator",
              description: "Outil convivial pour l'import/export fluide de donnees vectorielles",
            },
            {
              title: "SEPM X-Raster",
              description: "Import/export de donnees raster",
            },
            {
              title: "Interface SEPM NEPLAN",
              description: "Integration simplifiee de l'analyse de reseau",
            },
            {
              title: "Interface SEPM INTERLIS",
              description: "Connexion fluide des systemes SIG avec un import/export INTERLIS robuste pour les modeles de donnees suisses",
            },
            {
              title: "Interface SEPM ISYBAU",
              description: "Integrez facilement les donnees XML ISYBAU avec Smallworld NRM Wastewater pour importer et exporter les donnees d'inspection terrain codees selon DWA-M 149-2 ou DIN EN 13508-2",
            },
            {
              title: "Services SEPM",
              description: "Des migrations SIG aux solutions logicielles sur mesure, SEPM fournit des services innovants, precis et tournes vers l'avenir adaptes a vos besoins geospatiaux",
            },
          ],
        },
        newFeature: {
          sectionTitle: "Nouvelle fonctionnalite : decouvrez les nouveautes !!",
          sectionDescription: "Profitez d'un niveau de fonctionnalite superieur avec nos dernieres mises a jour",
          introLine1: "La version SEPM 2026-01 inclut des ameliorations importantes pour SEPM X-Translator,",
          introLine2: "l'interface SIA405 et les outils de migration VSE.:",
          imageAlt: "Nouvelle fonctionnalite",
          features: [
            {
              title: "Versions Smallworld prises en charge",
              description: [
                "Pris en charge et teste sur Smallworld 5.1, 5.2, 5.3 et 6.0.",
              ],
            },
            {
              title: "Nouvel ecran de parametres pour X-Translator",
              description: [
                "Les parametres globaux de X-Translator peuvent desormais etre geres via un ecran centralise.",
                "Cette version prend en charge la configuration des entrees Simple GUI.",
                "Des commandes d'import et d'export personnalisees peuvent etre definies comme configurations Simple GUI dans un fichier XML.",
                "Cela facilite la mise a disposition des configurations XML existantes aux utilisateurs finaux."
              ],
            },
            {
              title: "Import DXF/DWG ameliore avec tables de blocs",
              description: [
                "Les objets AutoCAD INSERT peuvent etre exploses et stockes dans des tables de blocs dediees du traducteur.",
                "Le contenu des blocs, les geometries et les attributs de style supplementaires deviennent disponibles dans un format structure pour le mapping et les traitements ulterieurs.",
              ],
            },
            {
              title: "Ameliorations du format source DXF/DWG",
              description: [
                "De nouvelles options et regles permettent l'import cible des attributs de blocs invisibles.",
                "Les conflits de nommage avec les attributs de blocs peuvent etre evites grace a des regles de traitement ameliorees.",
                "L'ancienne option \"Explode Blocks\" a ete remplacee par un mode d'import des blocs plus granulaire.",
              ],
            },
            {
              title: "Export DWG/DXF ameliore",
              description: [
                "L'export AutoCAD prend desormais en charge des decorations de texte Smallworld supplementaires comme les bordures, soulignements, textes barres et interruptions de texte.",
              ],
            },
            {
              title: "Ameliorations des exports Smallworld",
              description: [
                "La selection d'objets via Collection Predicates a ete decouplee de la visibilite ACE actuelle.",
                "Le reglage de visibilite \"All Geometries\" a ete etendu, permettant des exports complets independants de la visibilite GIS interactive.",
              ],
            },
            {
              title: "Ameliorations du format cible Smallworld",
              description: [
                "Un nouveau mode de valeur par defaut, \"Strict (no mandatory attribute check)\", a ete ajoute.",
                "La gestion des mondes cibles manquants a ete amelioree avec de nouvelles options pour controler les notifications de changement en base et la validation de cardinalite.",
              ],
            },
            {
              title: "Ameliorations pour KML, Text et Shape",
              description: [
                "L'export KML utilise maintenant l'espace de noms KML officiel, propose une nouvelle option pour les dimensions de coordonnees et n'exporte plus altitudeMode par defaut.",
                "Dans le format source Text, la detection du type d'attribut et la gestion des cellules vides ont ete ameliorees.",
                "Dans le format cible Shape, le nombre de decimales pour les attributs float et double peut etre configure.",
              ],
            },
            {
              title: "Prise en charge d'INTERLIS 2.4 et SIA405 LKMap 2025",
              description: [
                "La nouvelle interface \"NIS Strom SIA 405, LKMAP (2025), LV95, INTERLIS 2.4 XTF\" a ete ajoutee.",
                "Elle prend en charge les balises INTERLIS 2.4, UUIDOID, les references organisationnelles externes et les objets LKMap connus dans le nouveau modele.",
              ],
            },
            {
              title: "Ameliorations de la migration GEONIS",
              description: [
                "La migration de GEONIS vers NIS Strom via le modele intermediaire VSE a ete amelioree.",
                "Cela inclut une meilleure migration des profils de tracons, des numeros de conduites issus des profils GEONIS, ainsi que de meilleures fonctions de diagnostic et de reporting.",
              ],
            },
            {
              title: "Nouvelle migration Topobase",
              description: [
                "Un nouveau framework, topobase_vse_migration, a ete developpe pour transferer Autodesk Map 3D / Oracle Topobase vers VSE.",
                "Il prend en charge les objets cles des plans de construction, les relations entre traces, conduites et cables, la topologie electrique ainsi que les geometries de surface des objets structurels.",
              ],
            },
          ],
        },
        downloads: {
          sectionTitle: "Telechargements produits et support",
          sectionDescription: "Decouvrez notre toute derniere version - telechargez-la ici",
          downloadFile: "sepm_26_1_0_source.zip",
          releaseNotesEnglish: "Notes de version anglais",
          releaseNotesGerman: "Notes de version allemand",
        },
        partners: {
          sectionTitle: "Nos partenaires",
          sectionDescription: "Favoriser la reussite grace a notre reseau de partenaires strategiques de confiance",
        },
        testimonials: {
          sectionTitle: "Ce que disent nos clients",
          sectionDescription: "Decouvrez les retours de nos utilisateurs qui partagent leurs experiences et racontent comment nos solutions ont fait la difference. Leurs commentaires nous motivent a nous ameliorer en continu et a offrir une valeur exceptionnelle.",
          reviews: [
            {
              name: "Erwin Sagesser NIS AG",
              title: "NIS AG",
              review: "Un point de verite unique est possible - les interfaces SEPM eliminent les travaux de post-traitement chronophages apres des transformations de donnees complexes. Pour cette raison, SEPM permet aux clients de reutiliser efficacement leurs donnees qualifiees dans notre systeme d'information reseau NIS Strom",
            },
            {
              name: "Mario Schuler EW Schwyz",
              title: "",
              review: "Les informations reseau n'ont plus besoin d'etre saisies manuellement dans NEPLAN via un processus long. Elles sont gerees de facon centralisee dans NIS Strom et peuvent etre transferees facilement avec l'interface SEPM NEPLAN. La maintenance de base de donnees redondante et sujette aux erreurs n'est plus necessaire.",
            },
            {
              name: "Bernd Grossmann Ville de Leverkusen",
              title: "",
              review: "Convivial, simple et efficace : SEPM X-Translator a prouve son utilite non seulement pour les taches d'import/export standard. Les tableaux de coordonnees sont convertis en objets ponctuels avec annotations en un rien de temps. Le transfert de donnees de Smallworld a Smallworld ajoute un outil interessant a la boite a outils.",
            },
            {
              name: "Davy Bielen Fluvius",
              title: "",
              review: "Grace a la simplicite d'utilisation de SEPM X-Translator, nous avons pu optimiser nos processus metier.",
            },
            {
              name: "Eric Kappmeier MID",
              title: "",
              review: "Nos utilisateurs Smallworld utilisent SEPM X-Translator depuis des annees pour convertir les donnees Shape et DXF/DWG vers et depuis notre base de donnees GIS Smallworld. Nous pensons que c'est de loin l'outil le plus simple, le plus precis et le plus rentable pour partager des donnees spatiales entre Smallworld et d'autres systemes GIS.",
            },
          ],
        },
        footer: {
          contactUsText: "NOUS CONTACTER",
          contactUsDesc: "Robert Schweikert \n Geliswilstrasse 42, CH-6020 Emmenbrucke, Suisse, \n +41 79 632 28 20, \n info@sepm.ch",
          platformsText: "Produits SEPM | X-Translator | X-Raster | NEPLAN | INTERLIS | ISYBAU",
          copyrightText: "Copyright © 2025 SEPM, Inc. Tous droits reserves.",
          sections: [
            {
              title: "CONNECTEZ-VOUS AVEC NOUS",
              links: [
                { text: "LinkedIn" },
                { text: "Support SEPM" },
              ],
            },
          ],
        },
        common: {
          loading: "Chargement...",
          selectLanguage: "Selectionner la langue",
          languages: {
            en: "Anglais",
            fr: "Francais",
            de: "Allemand",
          },
        },
      },
    },
    de: {
      translation: {
        nav: {
          testToday: "SEPM heute testen!",
          products: "Produkte",
          partners: "Unsere Partner",
          testimonials: "Referenzen",
          releaseNotes: "Versionshinweise",
          download: "Herunterladen",
          tagline: "GIS-Workflow-Lösungen",
        },
        hero: {
          badgeText: "🚀 SEPM-Produkte 2026-01 jetzt verfugbar!",
          mainHeading: "GIS-Workflows optimieren \n fur Smallworld-Nutzer",
          subHeading: "Stellen Sie sich ein GIS-Tool vor, das so intuitiv ist, dass Ihr Team weniger Zeit mit der Fehlerbehebung und mehr Zeit mit Innovation verbringt.",
          msgText: "Smallworld-GIS-Nutzer haben oft mit ineffizienten Werkzeugen fur die Datenkonvertierung zu kampfen, die zu Verzogerungen und Fehlern fuhren.\n\n Bei SEPM \n vereinfachen wir das GIS-Datenmanagement, damit sich Ingenieure auf Entscheidungen statt auf technische Hurden konzentrieren konnen",
          imageAlt: "Streamer-SaaS-Oberflache",
        },
        howItWorks: {
          sectionTitle: "Testen Sie den SEPM X-Translator noch heute!",
          sectionDescription: "Der Einstieg ist einfach - folgen Sie diesen Schritten:",
          steps: [
            {
              title: "Laden Sie das SEPM-Produkt herunter",
              description: "Verwenden Sie den untenstehenden Link, um den SEPM X-Translator herunterzuladen",
            },
            {
              title: "Aktivieren Sie Ihre SEPM-Lizenz",
              description: "Kontaktieren Sie SEPM oder einen unserer vertrauenswurdigen Partner, um das Passwort fur die heruntergeladene ZIP-Datei sowie Anweisungen zum Hinzufugen des SEPM-Produkts zu Ihrer Smallworld-Sitzung zu erhalten",
            },
            {
              title: "Prufen Sie die Dokumentation",
              description: "Folgen Sie der Quickguide.pdf und weiterer SEPM-Dokumentation, um den Import und Export von Daten zu testen. Probieren Sie gangige Dateiformate wie DXF, GeoJSON, Shape oder KML aus.",
            },
            {
              title: "Entdecken Sie die Funktionen",
              description: "Wir helfen Ihnen gerne! SEPM oder unsere vertrauenswurdigen Partner konnen Sie durch die Grundlagen fuhren und erweiterte Funktionalitaten fur Ihre Anforderungen vorstellen.",
            },
            {
              title: "Schliessen Sie das Onboarding ab",
              description: "Arbeiten Sie mit SEPM oder einem Vertriebspartner zusammen, um eine erfolgreiche Einrichtung und Integration in Ihren Workflow sicherzustellen.",
            },
          ],
          lastStep: "Starten Sie noch heute Ihre SEPM-Reise und revolutionieren Sie Ihre GIS-Workflows!",
        },
        keyFeatures: {
          sectionTitle: "Unsere Produktsuite fur nahtlose GIS-Workflows",
          sectionDescription: "Da sich weltweit uber 250 Unternehmen auf unsere Losungen verlassen, haben wir Werkzeuge entwickelt, die GIS-Workflows optimieren",
          features: [
            {
              title: "SEPM X-Translator",
              description: "Benutzerfreundliches Werkzeug fur nahtlosen Import/Export von Vektordaten",
            },
            {
              title: "SEPM X-Raster",
              description: "Import/Export von Rasterdaten",
            },
            {
              title: "SEPM NEPLAN-Schnittstelle",
              description: "Vereinfachte Integration der Netzwerkanalyse",
            },
            {
              title: "SEPM INTERLIS-Schnittstelle",
              description: "Nahtlose Verbindung von GIS-Systemen mit robustem INTERLIS-Import/Export fur Schweizer Datenmodelle",
            },
            {
              title: "SEPM ISYBAU-Schnittstelle",
              description: "Integrieren Sie ISYBAU-XML-Daten muhelos mit Smallworld NRM Wastewater, um Felddaten nach DWA-M 149-2 oder DIN EN 13508-2 zu importieren und zu exportieren",
            },
            {
              title: "SEPM Services",
              description: "Von GIS-Migrationen bis zu massgeschneiderten Softwarelosungen liefert SEPM innovative, prazise und zukunftssichere Services fur Ihre geospatialen Anforderungen",
            },
          ],
        },
        newFeature: {
          sectionTitle: "Neue Funktion: Entdecken Sie, was neu ist!!",
          sectionDescription: "Erleben Sie mit unseren neuesten Updates die nachste Funktionsstufe",
          introLine1: "Version SEPM 2026-01 enthaelt umfangreiche Erweiterungen und Verbesserungen fuer den SEPM X-Translator,",
          introLine2: "die SIA405-Schnittstelle und die VSE-Migrationswerkzeuge.:",
          imageAlt: "Neue Funktion",
          features: [
            {
              title: "Unterstuetzte Smallworld-Versionen",
              description: [
                "Unterstuetzt und getestet auf Smallworld 5.1, 5.2, 5.3 und 6.0.",
              ],
            },
            {
              title: "Neuer Einstellungsbildschirm fuer X-Translator",
              description: [
                "Globale X-Translator-Einstellungen koennen jetzt ueber einen zentralen Einstellungsbildschirm verwaltet werden.",
                "Diese Version unterstuetzt speziell die Konfiguration von Simple-GUI-Eintraegen.",
                "Benutzerdefinierte Import- und Exportbefehle koennen als Simple-GUI-Konfigurationen in einer XML-Datei definiert werden.",
                "Damit lassen sich bestehende XML-Konfigurationen einfacher fuer Endanwender bereitstellen."
              ],
            },
            {
              title: "Erweiterter DXF/DWG-Import mit Blocktabellen",
              description: [
                "AutoCAD-INSERT-Objekte koennen aufgeloest und in dedizierten Translator-Blocktabellen gespeichert werden.",
                "Dadurch stehen Blockinhalte, Geometrien und zusaetzliche Stilattribute in einem strukturierten Format fuer Mapping und Weiterverarbeitung zur Verfuegung.",
              ],
            },
            {
              title: "Verbesserungen am DXF/DWG-Quellformat",
              description: [
                "Neue Optionen und Regeln ermoeglichen den gezielten Import unsichtbarer Blockattribute.",
                "Namenskonflikte mit Blockattributen koennen durch verbesserte Verarbeitungsregeln vermieden werden.",
                "Die bisherige Option \"Explode Blocks\" wurde durch einen granulareren Block-Importmodus ersetzt.",
              ],
            },
            {
              title: "Erweiterter DWG/DXF-Export",
              description: [
                "Der AutoCAD-Export unterstuetzt nun zusaetzliche Smallworld-Textdekorationen wie Rahmen, Unterstreichungen, Durchstreichungen und Textaussparungen.",
              ],
            },
            {
              title: "Verbesserungen bei Smallworld-Exporten",
              description: [
                "Die Objektauswahl ueber Collection Predicates wurde von der aktuellen ACE-Sichtbarkeit entkoppelt.",
                "Die Sichtbarkeitseinstellung \"All Geometries\" wurde erweitert und ermoeglicht vollstaendige Exporte unabhaengig von der interaktiven GIS-Sichtbarkeit.",
              ],
            },
            {
              title: "Verbesserungen am Smallworld-Zielformat",
              description: [
                "Ein neuer Standardwertmodus, \"Strict (no mandatory attribute check)\", wurde hinzugefuegt.",
                "Die Behandlung fehlender Zielwelten wurde verbessert, mit neuen Optionen zur Steuerung von Datenbankaenderungsmeldungen und Kardinalitaetspruefung.",
              ],
            },
            {
              title: "Verbesserungen fuer KML, Text und Shape",
              description: [
                "Der KML-Export verwendet jetzt den offiziellen KML-Namensraum, bietet eine neue Option fuer Koordinatendimensionen und exportiert altitudeMode standardmaessig nicht mehr.",
                "Im Text-Quellformat wurden die Attributtyperkennung und die Behandlung leerer Zellen verbessert.",
                "Im Shape-Zielformat kann die Anzahl der Nachkommastellen fuer Float- und Double-Attribute konfiguriert werden.",
              ],
            },
            {
              title: "Unterstuetzung fuer INTERLIS 2.4 und SIA405 LKMap 2025",
              description: [
                "Die neue Schnittstelle \"NIS Strom SIA 405, LKMAP (2025), LV95, INTERLIS 2.4 XTF\" wurde hinzugefuegt.",
                "Sie unterstuetzt INTERLIS-2.4-Tags, UUIDOID, externe organisatorische Referenzen sowie die bekannten LKMap-Objekte im neuen Modell.",
              ],
            },
            {
              title: "Erweiterungen der GEONIS-Migration",
              description: [
                "Die Migration von GEONIS nach NIS Strom ueber das VSE-Zwischenmodell wurde erweitert.",
                "Dazu gehoeren eine verbesserte Migration von Trassenquerschnitten, Rohrnummern aus GEONIS-Querschnitten sowie bessere Diagnose- und Reporting-Funktionen.",
              ],
            },
            {
              title: "Neue Topobase-Migration",
              description: [
                "Ein neues Framework, topobase_vse_migration, wurde fuer die Uebertragung von Autodesk Map 3D / Oracle Topobase nach VSE entwickelt.",
                "Es unterstuetzt zentrale Bauplanobjekte, Beziehungen zwischen Trassen, Rohren und Kabeln, elektrische Topologie sowie Flaechengeometrien fuer Strukturobjekte.",
              ],
            },
          ],
        },
        downloads: {
          sectionTitle: "Produktdownloads und Support",
          sectionDescription: "Erleben Sie unsere neueste Version - hier herunterladen",
          downloadFile: "sepm_26_1_0_source.zip",
          releaseNotesEnglish: "Release Notes Englisch",
          releaseNotesGerman: "Release Notes Deutsch",
        },
        partners: {
          sectionTitle: "Unsere Partner",
          sectionDescription: "Erfolg durch unser vertrauenswurdiges Netzwerk strategischer Partner",
        },
        testimonials: {
          sectionTitle: "Was unsere Kunden sagen",
          sectionDescription: "Erfahren Sie, was einige unserer geschatzten Nutzer uber ihre Erfahrungen berichten und wie unsere Losungen einen Unterschied gemacht haben. Ihr Feedback motiviert uns, uns stetig zu verbessern und aussergewohnlichen Mehrwert zu liefern.",
          reviews: [
            {
              name: "Erwin Sagesser NIS AG",
              title: "NIS AG",
              review: "Ein zentraler Single Point of Truth ist moglich - die SEPM-Schnittstellen beseitigen zeitaufwandige Nachbearbeitung nach komplexen Datentransformationen. Deshalb ermoglicht SEPM Kunden die effiziente Wiederverwendung ihrer qualitatsgesicherten Daten in unserem Netzinformationssystem NIS Strom",
            },
            {
              name: "Mario Schuler EW Schwyz",
              title: "",
              review: "Netzinformationen mussen nicht mehr zeitaufwandig von Hand in NEPLAN eingegeben werden. Sie werden zentral in NIS Strom verwaltet und konnen komfortabel mit der SEPM-NEPLAN-Schnittstelle ubertragen werden. Redundante und fehleranfallige Datenbankpflege ist nicht mehr notwendig.",
            },
            {
              name: "Bernd Grossmann Stadt Leverkusen",
              title: "",
              review: "Benutzerfreundlich, unkompliziert und auf den Punkt: SEPM X-Translator hat seinen Nutzen nicht nur fur Standard-Import- und Exportaufgaben bewiesen. Tabellen mit Koordinaten werden in kurzer Zeit in Punktobjekte mit Annotationen umgewandelt. Der Datentransfer von Smallworld zu Smallworld erweitert den Werkzeugkasten um ein interessantes Instrument.",
            },
            {
              name: "Davy Bielen Fluvius",
              title: "",
              review: "Dank des einfach zu bedienenden SEPM X-Translator konnten wir Geschaftsprozesse optimieren.",
            },
            {
              name: "Eric Kappmeier MID",
              title: "",
              review: "Unsere Smallworld-Nutzer verwenden SEPM X-Translator seit Jahren, um Shape- und DXF/DWG-Daten in unsere Smallworld-GIS-Datenbank hinein und heraus zu konvertieren. Wir sind uberzeugt, dass es mit Abstand das einfachste, praziseste und kosteneffizienteste Werkzeug fur den Austausch raumbezogener Daten zwischen Smallworld und anderen GIS-Systemen ist.",
            },
          ],
        },
        footer: {
          contactUsText: "KONTAKT",
          contactUsDesc: "Robert Schweikert \n Geliswilstrasse 42, CH-6020 Emmenbrucke, Schweiz, \n +41 79 632 28 20, \n info@sepm.ch",
          platformsText: "SEPM Produkte | X-Translator | X-Raster | NEPLAN | INTERLIS | ISYBAU",
          copyrightText: "Copyright © 2025 SEPM, Inc. Alle Rechte vorbehalten.",
          sections: [
            {
              title: "VERBINDEN SIE SICH MIT UNS",
              links: [
                { text: "LinkedIn" },
                { text: "SEPM Support" },
              ],
            },
          ],
        },
        common: {
          loading: "Laden...",
          selectLanguage: "Sprache auswahlen",
          languages: {
            en: "Englisch",
            fr: "Franzosisch",
            de: "Deutsch",
          },
        },
      },
    },
  };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    lng: "en",
    resources:resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
